import { useEffect, useState } from "react";
import { Card, Wrapper } from "../CommonComponents/DataCard";
import MessageCard from "../CommonComponents/MessageCard";
import { getUserMessages } from "../../services/MessageService";

function Notification({ user, onMessagesUpdate }) {
    const [messages, setMessages] = useState([]);

    async function loadMessages() {
        try {
            const response = await getUserMessages();
            setMessages(response);
            const hasUnread = response.some(m => !m.isRead);
            onMessagesUpdate(hasUnread);
        } catch (err) {
            console.error("Greška pri učitavanju poruka:", err);
        }
    }

    useEffect(() => {
        loadMessages();
    }, []);

    return (
        <Wrapper>
            <Card>
                {messages.length === 0 ? (
                    <p>Nema novih poruka.</p>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", width: "100%" }}>
                        {messages.map((msg) => (
                            <MessageCard
                                key={msg.id}
                                message={msg}
                                onRead={() => loadMessages()}
                            />
                        ))}
                    </div>
                )}
            </Card>
        </Wrapper>
    );
}

export default Notification;
